import CloseIcon from "@mui/icons-material/Close";
import CloseFullscreenIcon from "@mui/icons-material/CloseFullscreen";
import OpenInFullIcon from "@mui/icons-material/OpenInFull";
import Box from "@mui/material/Box";
import Dialog from "@mui/material/Dialog";
import DialogContent from "@mui/material/DialogContent";
import DialogTitle from "@mui/material/DialogTitle";
import IconButton from "@mui/material/IconButton";
import Typography from "@mui/material/Typography";
import { ReactNode, useState } from "react";

interface Props {
  title: string;
  open: boolean;
  onClose: () => void;
  children: ReactNode;
}

export function DocsDrawer({ title, open, onClose, children }: Props) {
  const [fullscreen, setFullscreen] = useState(false);

  const handleClose = () => {
    onClose();
    setFullscreen(false);
  };

  return (
    <Dialog
      open={open}
      onClose={handleClose}
      fullScreen={fullscreen}
      maxWidth="md"
      fullWidth
      PaperProps={{
        sx: fullscreen
          ? undefined
          : { position: "fixed", right: 0, m: 0, height: "100vh", maxHeight: "100vh", borderRadius: 0 },
      }}
    >
      <DialogTitle sx={{ display: "flex", alignItems: "center", gap: 1, pr: 1 }}>
        <Typography variant="h6" sx={{ flex: 1 }}>
          {"Hilfe — "}
          {title}
        </Typography>
        <IconButton onClick={() => setFullscreen(f => !f)} size="small">
          {fullscreen ? <CloseFullscreenIcon fontSize="small" /> : <OpenInFullIcon fontSize="small" />}
        </IconButton>
        <IconButton onClick={handleClose} size="small">
          <CloseIcon fontSize="small" />
        </IconButton>
      </DialogTitle>
      <DialogContent dividers>
        <Box sx={{ maxWidth: fullscreen ? 900 : undefined, mx: fullscreen ? "auto" : undefined }}>
          {children}
        </Box>
      </DialogContent>
    </Dialog>
  );
}
